/**
 * File service for handling file operations in the browser
 */
export const fileService = {
  /**
   * Save a blob as a file with browser download dialog
   * @param blob The blob data to save
   * @param filename The suggested filename for the download
   */
  saveFile: (blob: Blob, filename: string): void => {
    try {
      // Create a link element to trigger the download
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = filename;
      
      // Append to the document, click to download, then remove
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      
      // Clean up the object URL
      window.URL.revokeObjectURL(downloadLink.href);
    } catch (error) {
      console.error('File save error:', error);
      throw error;
    }
  }
};